import { IActionConfigs } from 'hooks/useFetch';
import { APILinks } from 'constants/api';
import { ActionTypes } from 'constants/actionTypes';
import { States } from 'constants/states';

export const bannersConfigs: IActionConfigs = {
  apiLink: APILinks.BANNERS,
  actionType: ActionTypes.BANNERS,
  state: States.BANNERS,
};
